import type { ReactNode } from "react";
import type { Bucket } from "../util/buckets";

// Qayta ishlatiladigan ustunli grafik. Oldindan guruhlangan `{label,count}`
// bo'laklarni oladi, balandlikni eng katta bo'lakka nisbatan beradi (qat'iy px emas),
// va ma'lumot bo'lmasa bo'sh holat matnini ko'rsatadi — hech qachon bo'sh kulrang
// kataklar emas. 8 tagacha bo'lakda har ustun tepasida son va ostida yorliq
// chiqadi; ko'p bo'lakda ixcham rejimga o'tib, faqat birinchi/oxirgi o'q yorlig'i
// ko'rsatiladi (sonlar hover orqali).
export function BarTrend({
  buckets,
  emptyText,
  summary,
}: {
  buckets: Bucket[];
  emptyText: string;
  summary?: ReactNode;
}) {
  const total = buckets.reduce((s, b) => s + b.count, 0);
  if (buckets.length === 0 || total === 0) {
    return <div className="empty">{emptyText}</div>;
  }

  const max = Math.max(1, ...buckets.map((b) => b.count));
  const labeled = buckets.length <= 8;

  return (
    <>
      <div className="trend-bars">
        {buckets.map((b, i) => (
          <div className="trend-col" key={`${b.label}-${i}`} title={`${b.label}: ${b.count}`}>
            {labeled && <div className="trend-count">{b.count}</div>}
            <div className="trend-bar-track">
              <div
                className={b.count === 0 ? "trend-bar empty" : "trend-bar"}
                style={{ height: b.count === 0 ? undefined : `${Math.max(6, (b.count / max) * 100)}%` }}
              />
            </div>
            {labeled && <div className="trend-label">{b.label}</div>}
          </div>
        ))}
      </div>
      {!labeled && (
        <div className="bars-axis">
          <span>{buckets[0].label}</span>
          <span>{buckets[buckets.length - 1].label}</span>
        </div>
      )}
      {summary && <div className="trend-summary">{summary}</div>}
    </>
  );
}
